import styled from '@emotion/styled';
import { Box, Button } from '@mui/material';

export const ButtonStyles = styled(Button)`
  margin-left: -52px;
  backdrop-filter: blur(3px);

  position: relative;
  left: 100px;

  border: 1px solid rgb(196, 196, 196);
  min-width: 30px;

  transition: left 200ms;
`;

export const ContainerStyles = styled(Box)`
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;

  :hover .btn {
    left: 0px;
  }
`;
